export const SHARE_VIEW_PARAM = 'shareView';
export const SHARE_VIEW_DEBUG_PARAM = 'shareView_debug_frontend';
